import React from 'react';
export function StatCard({
  label,
  value
}: {
  label: string;
  value: string | number;
}) {
  return <div className="flex-1 rounded-lg border border-ink-200 bg-white px-5 py-4" data-id="element-400" data-mp="2y5kjf8ebh9id">
      <p className="text-[13px] text-ink-500" data-id="element-401" data-mp="2jgof9mfdsgn1">{label}</p>
      <p className="mt-1 text-[22px] font-bold leading-tight tracking-tight text-ink-900" data-id="element-402" data-mp="2ji99faxs9xkd">{value}</p>
    </div>;
}